import { CLOSE_RATIO, SNAP_RATIOS, SnapKeys,SnapSizes } from "../constants";

export const toDvh = (snap: SnapKeys) => `${SNAP_RATIOS[snap] * 100}dvh`;

type ReleaseState = { size: SnapKeys; height: number; viewport: number; isFlick: boolean; isDown: boolean };

export function resolveRelease({ size, height, viewport, isFlick, isDown }: ReleaseState): SnapKeys | "closed" {
  const midHeight = viewport * SNAP_RATIOS.mid;
  const closeHeight = midHeight * CLOSE_RATIO;

  if (isFlick) {
    if (!isDown) return "full";
    return size === "full" && height > closeHeight ? "mid" : "closed";
  }
  if (height < closeHeight) return "closed";
  return Math.abs(height - midHeight) <= Math.abs(height - viewport) ? "mid" : "full";
}
